// ./src/contexts/VenuesContext/VenuesContext.tsx
import React, { createContext, useContext } from "react";
import { UseVenuesReturn, UseVenuesOptions, useVenues } from "@/hooks";

export interface VenuesContextValue extends UseVenuesReturn {
  // Additional context-specific methods if needed in the future
}

export interface VenuesProviderProps {
  children: React.ReactNode;
  options?: UseVenuesOptions;
}

const VenuesContext = createContext<VenuesContextValue | undefined>(undefined);

export const VenuesProvider: React.FC<VenuesProviderProps> = ({
  children,
  options = {},
}) => {
  const venuesHook = useVenues(options);

  return (
    <VenuesContext.Provider value={venuesHook}>
      {children}
    </VenuesContext.Provider>
  );
};

// Custom hook for using the venues context
export const useVenuesContext = (): VenuesContextValue => {
  const context = useContext(VenuesContext);
  if (context === undefined) {
    throw new Error("useVenuesContext must be used within a VenuesProvider");
  }
  return context;
};
